const features = [
    {
        id: 1,
        title: 'Access Consumer Insights at Scale',
        content: 'Utilize Peekage\'s in-home product testing suite to effortlessly access consumer insights with just a few clicks, delivering results in days rather than weeks. Peekage seamlessly integrates all aspects of product testing—from automated study design and user recruitment to product fulfillment, data collection, and analysis—into one comprehensive suite of tools. This allows you to focus solely on your business questions and glean valuable insights efficiently.',
        image: 'insights/peekage-consumer-data-services.jpg',
        imageAlt: 'All in one Peekage consumer data services',
        class: '',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
        component: 'FeatureItem',
    },
    {
        id: 2,
        title: 'Harness Consumer Insights from Development to Launch and Growth',
        content:
            'Leverage rapid and iterative data sourced directly from customers at each stage of your product\'s journey. From the earliest stages of ideation, tap into the consumer voice to discern market gaps and refine your vision. Throughout product development, fine-tune your formula and packaging to craft the ideal product. At launch, pinpoint the optimal positioning and messaging to amplify your marketing ROI. As you progress, optimize your in-store experience and continuously innovate your product formula, packaging and product assortment to align with evolving market demands.',
        image: 'insights/insights-in-home-product-testing.jpg',
        imageAlt: 'Getting insights in-home product testing',
        component: 'FeatureItem',
        class: 'nth-reverse',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
    {
        id: 3,
        title: 'Exclusive community of high value consumers',
        headline: 'Representative Community of Consumers',
        content:
            'Peekage has a community of vibrant and highly engaged shoppers from diverse backgrounds who join Peekage to test new products and innovations. With a passion for trying new things, they willingly share their opinions and insights, including shopping habits, dietary preferences, interests, and routines. This valuable information enables you to recruit a diverse and representative sample of your target audience. Once matched with your research, they provide feedback on concepts, products, or packaging through surveys and interviews.',
        image: 'insights/peekage-consumer-panels.jpg',
        imageAlt: 'Peekage: Consumer panels',
        component: 'FeatureItem',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
        url: '/natural-shoppers-community',
        buttonTitle: 'Meet our community',
        isSpecialButton: true,
    },
    {
        id: 4,
        title: 'Learn about Customer In-Store Experience ',
        content: 'Peekage is one of the only platforms that enable you to capture users\' in-store experiences, offering invaluable insights into customers’ shopping trips, in-store dynamics, and your shelf space optimization. Learn about where customers are looking for your product, if they are able to find them, and see if your product stands out in a sea of different products. Delve into their basket size and contents, and understand other products they purchase alongside yours.',
        image: 'insights/increase-retail-sales-product-sampling-services.jpg',
        imageAlt: 'Increase retail sales with Peekage product sampling services',
        component: 'FeatureItem',
        class: 'nth-reverse',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
    {
        id: 5,
        title: 'Evaluate Product Performance Against Competitors',
        content: 'Discover how your product stacks up against competitors\' offerings with Peekage\'s blind testing solution. Gain detailed insights into various aspects such as formula, taste, and flavor profile compared to similar products in the market, identifying optimization opportunities. Peekage\'s blind testing solution provides unbiased insights to help you understand where your product stands in comparison.',
        image: 'insights/product-comparison-showcasing-in-home-usage-testing.jpg',
        imageAlt: 'Product comparison showcasing In-home usage testing',
        component: 'FeatureItem',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
    {
        id: 6,
        title: 'Get Actionable Insights, Not Just Raw Data',
        content:
            'Peekage\'s Insight Engine helps you make sense of data by transforming it into actionable insights. Our Insight Engine analyzes data and provides AI-based recommendations, enabling you to effortlessly translate insights into actionable decisions and eliminating the need for data science teams. ',
        image: 'insights/building-trust-product-testing-reviews.jpg',
        imageAlt: 'Building trust with product testing reviews',
        component: 'FeatureItem',
        class: 'nth-reverse',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
];

export default features;
